/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
import React from 'react';
import {
  Box, Typography, makeStyles, useMediaQuery,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import ContentWrap from '../atoms/ContentWrap';
import StyledButton from '../atoms/StyledButton';
import FooterMenuDesktop from '../atoms/FooterMenuDesktop';
import FooterMenuMobile from '../atoms/FooterMenuMobile';
import RedirectLink from '../atoms/RedirectLink';
import InstagramIcon from '../../static/images/social/instagram.png';
import FacebookIcon from '../../static/images/social/facebook.png';
import YoutubeIcon from '../../static/images/social/youTube.png';
import LinkedinIcon from '../../static/images/social/linkedIn.png';
import TiktokIcon from '../../static/images/social/tiktok.png';
import ConubeLogo from '../../static/images/logo-conube-branco.png';
import { useDrawerContext } from '../../contexts/DrawerContext';
import mindGroupIcon from '../../static/images/mind-group-icon.png';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '60px 0 25px 0',
    backgroundColor: theme.palette.primary.dark,

    '@media screen and (max-width: 1140px)': {
      padding: '40px 0 35px',
    },

    '& .MuiTypography-root': {
      color: theme.palette.primary.light,
    },

    '& .MuiLink-root, & .MuiLink-root .MuiTypography-root': {
      ...theme.typography.body2,
      color: theme.palette.secondary.contrastText,
    },

    '& .highlighted': {
      fontWeight: '700',
      letterSpacing: '0.065em',
    },
  },

  content: {
    display: 'grid',
    gridTemplateColumns: '320px 320px 260px',
    gap: '50px',
    justifyContent: 'space-between',

    '& .conube-data': {
      display: 'grid',
      gap: '20px',

      '& .section': {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
      },

      '& .documents': {
        display: 'flex',
        gap: '30px',

        '& .MuiTypography-root': {
          fontWeight: '700',
          fontSize: '14px',
          letterSpacing: '0.065em',
        },
      },
    },

    '& .button': {
      textAlign: 'right',
      display: 'flex',
      flexDirection: 'column',
      gap: '26px',

      '& .MuiTypography-body2': {
        fontWeight: 400,
      },
      '& .links': {
        display: 'flex',
        flexDirection: 'column',
        gap: '13px',
      },
    },

    '& .menu-mobile': {
      '@media screen and (min-width: 1140px)': {
        display: 'none',
      },
    },

    '@media screen and (max-width: 1140px)': {
      gridTemplateColumns: 'auto',

      '& .menu-desktop': {
        display: 'none',
      },
    },
  },
  addressBox: {
    display: 'none',
    '@media screen and (max-width: 1140px)': {
      display: 'block',
    },
  },
  bottom: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    alignItems: 'center',
    marginTop: '35px',
    paddingTop: '25px !important',
    borderTop: '0.6px solid #0092f5',

    '& .icons': {
      display: 'flex',
      justifySelf: 'right',
      gap: '15px',
    },

    '@media screen and (max-width: 1140px)': {
      display: 'flex',
      flexDirection: 'column-reverse',
      gap: '30px',
    },
  },

}));

const Footer = ({ taNaModa, isFooterWidgetOpen }) => {
  const classes = useStyles();
  const { setOpenDrawer } = useDrawerContext();
  const isMobile = useMediaQuery('(max-width:960px)');

  return (
    <Box
      className={classes.root}
      style={{
        marginBottom: (isFooterWidgetOpen || !isMobile) && '84px',
      }}
    >
      <ContentWrap>
        <Box>
          <Box className={classes.content}>
            <Box className="conube-data">
              <img src={ConubeLogo} alt="Logo da Conube" width="137px"  />

              <Box>
                <Typography variant="subtitle1">Conube Contabilidade Online LTDA</Typography>

                <Box className="documents">
                  <Typography variant="subtitle2">
                    CNPJ:
                    <br />
                    18.761.396/0001-55
                  </Typography>

                  <Typography variant="subtitle2">
                    CRC:
                    <br />
                    2SP032732
                  </Typography>
                </Box>
              </Box>

              <Box>
                <Typography variant="subtitle1">Conube Tecnologia e Serviços Ltda.</Typography>
                <Box className="documents">
                  <Typography variant="subtitle2">
                    CNPJ:
                    <br />
                    21.196.219/0001-88
                  </Typography>
                </Box>
              </Box>

              <Box className={classes.addressBox}>
                <Typography>
                  Endereço: Avenida Marques de São Vicente
                  Nº 182 - Várzea da Barra Funda,  Sala 54
                  São Paulo, SP - CEP 01139-000
                </Typography>
              </Box>

            </Box>

            <Box className="menu-desktop">
              <FooterMenuDesktop />
            </Box>

            <Box className="menu-mobile">
              <FooterMenuMobile />
            </Box>

            <Box className="button">
              <Box>
                {taNaModa ? (
                  <StyledButton
                    text="Fale com um consultor"
                    variant="outlined2"
                    color="white"
                    width="100%"
                    onClick={() => setOpenDrawer(true)}
                  />
                ) : (
                  <StyledButton
                    text="Saiba quanto custa"
                    variant="outlined2"
                    color="white"
                    width="100%"
                    component="a"
                    href="/quanto-custa/"
                    onClick={() => {
                      window.scrollTo(0, 0);
                    }}
                  />
                )}
              </Box>
              <Box className="links">
                <Typography variant="body1" className="highlighted">Portal de Ajuda</Typography>

                <RedirectLink href="https://faq.conube.com.br/" toNewTab>
                  <Typography variant="body2">Perguntas Frequentes</Typography>
                </RedirectLink>
                <RedirectLink href="/politica-de-privacidade/">
                  <Typography variant="body2">Política de Privacidade</Typography>
                </RedirectLink>
              </Box>
              <a target="_blank" rel="noopener noreferrer" href="https://mindgroupbr.com">
                <img src={mindGroupIcon} alt="Mind Group" width="105px" height="32px" />
              </a>
            </Box>
          </Box>

          <Box className={classes.bottom}>
            <Typography variant="body2">©2026 Conube - Todos direitos reservados</Typography>

            <Box className="icons">
              <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/conubecontabilidade">
                <img src={InstagramIcon} alt="Instagram icon" width="27px" height="27px" />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/conube/?locale=pt_BR">
                <img src={FacebookIcon} alt="Facebook icon" width="27px" height="27px" />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/@ConubeBr/featured">
                <img src={YoutubeIcon} alt="Youtube icon" width="27px" height="27px" />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/conube/?viewAsMember=true">
                <img src={LinkedinIcon} alt="Linkedin icon" width="27px" height="27px" />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.tiktok.com/@conubecontabilidade?_t=ZM-8zSAG74MwlC&_r=1">
                <img src={TiktokIcon} alt="Tiktok icon" width="27px" height="27px" />
              </a>
            </Box>
          </Box>
        </Box>
      </ContentWrap>
    </Box>
  );
};

Footer.prototype = {
  taNaModa: PropTypes.bool,
  isFooterWidgetOpen: PropTypes.bool.isRequired,
};

export default Footer;
